module.exports = __webpack_public_path__ + "img/Wessel_Smeden.9f5df969.jpg";